export const normalizePromoCode = value => (value || '').trim().toUpperCase();

export const isValidPromoCode = value => /^[A-Z0-9_-]{1,64}$/.test(normalizePromoCode(value));
